import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";

const GalleryStrip = () => {
  const images = [
    "/images/decoratingClasses/class1.jpg",
    "/images/decoratingClasses/class2.jpg",
    "/images/decoratingClasses/class3.jpg",
    "/images/decoratingClasses/class4.jpg",
  ];

  return (
    <Container sx={{ py: 0 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        A Look at Our Past Classes
      </Typography>
      <Grid container spacing={2}>
        {images.map((src, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              component="img"
              src={src}
              alt={`Class ${index + 1}`}
              sx={{ width: "100%", borderRadius: 2 }}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default GalleryStrip;
